import { Component, input, output } from "@angular/core";
import { AvatarColors, SystemColors } from "../../core/enums/base.enums";
import { RandomUtilities } from "../../core/utilities/random.utilities";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { SelectionPrimaryKeys } from "../../core/enums/data.enums";

@Component({
  selector: 'ms-mobile-card-checkbox',
  imports: [FontAwesomeModule],
  templateUrl: './mobile-card-checkbox.html',
  styleUrl: './mobile-card-checkbox.scss'
})
export class MobileCardCheckbox {
  public item = input<any | undefined | null>(null);
  public selectionPrimaryKey = input<SelectionPrimaryKeys | undefined>(undefined);

  public checkboxSize = input("50px");
  public checkboxShape = input("circle");
  public checkboxAdditionalAttributes = input("");
  public isLoading = input(false);
  public isSelected = input(false);
  public isDisabled = input(false);

  // Optional glyph rendered inside the circle in the unselected state (e.g. a folder/file icon).
  // Omitted by default so existing callers keep the plain empty circle.
  public icon = input<string | undefined>(undefined);
  public iconSecondaryOpacity = input("0.4");
  public iconPrimaryOpacity = input("1");

  // Explicit id for items keyed by a computed value rather than one model property (a payment is
  // keyed by paymentId or manualPaymentId). Falls back to item[selectionPrimaryKey] when omitted.
  public itemId = input<number | undefined>(undefined);

  // Label for items that carry no `name` to derive one from.
  public ariaLabel = input<string | undefined>(undefined);

  public clicked = output<any>();

  public backgroundColor: string = MobileCardCheckbox.generateCheckboxColorClass();
  public altText: string = "";
  public checkboxClass: string = "";
  public disabledHexColor: string = SystemColors.DisabledGray;

  constructor() {}

  public ngOnInit() {
    this.checkboxClass = MobileCardCheckbox.getCheckboxClass(this.checkboxSize(), this.checkboxShape(), this.checkboxAdditionalAttributes());
  }

  public checkboxClicked() : void {
    if (this.isDisabled()) return;
    const id = this.getItemId();
    const data = {id: id, checked: !this.isSelected()};
    this.clicked.emit(data);
  }

  public onCheckboxChange(event: Event): void {
    if (this.isDisabled()) return;
    const checkbox = event.target as HTMLInputElement;
    const id = this.getItemId();
    const data = {id: id, checked: checkbox.checked};
    this.clicked.emit(data);
  }

  public getItemId(): number | undefined {
    const explicitId = this.itemId();
    if (explicitId !== undefined) return explicitId;

    const item = this.item();
    if (!item || !this.selectionPrimaryKey()) return undefined;
        
    return item[this.selectionPrimaryKey()!];
  }

  public getAriaLabel(): string {
    const label = this.ariaLabel();
    if (label) return label;

    let name: string = "";
    const item = this.item();
    if (!item) return 'Select item';
    
    switch (this.selectionPrimaryKey()) {

      case SelectionPrimaryKeys.OrganizationId:
      case SelectionPrimaryKeys.PropertyId:
      case SelectionPrimaryKeys.PropertyChargeScheduleId:
      case SelectionPrimaryKeys.DocumentNodeId:
        name = item.name;
        break;

      default:
        name = "";
    }   
    
    return name ? `Select ${name}` : 'Select item';
  }

  private static getCheckboxClass(checkboxSize: string, checkboxShape: string, checkboxAdditionalAttributes: string): string {
    return `symbol symbol-${checkboxSize} symbol-${checkboxShape} ${checkboxAdditionalAttributes}`;
  }
  
  private static generateCheckboxColorClass(): string {
    const color = RandomUtilities.getRandomValue(AvatarColors);
    return color;
  }
}